import React, { useEffect, useState } from "react"
import { Button, Col, Container, Form, Row } from "react-bootstrap"
import { useParams, useNavigate } from "react-router-dom"
import { DSMReportGenerate, fetchAPIData, isLoggedIn, notAuthorized } from "../../api/AuthService"
import { DS_SUBMIT, ExpirationDate, FETCH_DS_FORM_DATA, otherState, policyVisible, ProductDataType, qualificationState } from "../../constant/Constants"
import HeaderComponent from "../commonComponents/HeaderComponent"
import textValidation from "../dynamicReports/ReportTemplates/textValidation"
import SearchDSData from "./SearchDSData"
import SearchGCASData from "./SearchGCASData"

function CreateDynamicSub(props) {
   const { searchID } = useParams()
   const navigate = useNavigate()
   const userID = localStorage.getItem("UserId")
   const [formData, setFormData] = useState(
      {
         productDataType: "",
         SubsFrequency: "Daily",
         Policy: "",
         State: "Release",
         Organization: "",
         Gcas: "",
         Vendor: "",
         Plant: "",
         Brand: "",
         Segment: "",
         ManuFacturingStatus: "",
         Owner: "",
         expirationDate: "",
         subscriptionID: searchID || "",
         subscriptionName: ""
      })
   const [modalShow, setModalShow] = useState(false)
   const [showGCASModal, setShowGCASModal] = useState(false)
   const [from, setFrom] = useState("")
   const [blinkSearch, setBlinkSearch] = useState("reportOptions")
   const [message, setMessage] = useState("")
   const [showAllWarning, setShowAllWarning] = useState(false)
   const [success, setSuccess] = useState(false)
   const [doneLoading, setDoneLoading] = useState(false)
   const [disable, setDisable] = useState(false)

   async function fetchData() {
      //Get data by API call
      try {
         const response = await fetchAPIData(`${FETCH_DS_FORM_DATA}/${searchID}`)
         if (response && response.data) {
            const schemaTypeName = response.data.subscriptionDetails["schemaTypeName"]
            setFormData((data) => ({
               ...data,
               productDataType: typeof schemaTypeName === 'object' ? schemaTypeName.value : schemaTypeName,
               Policy: response.data.subscriptionDetails?.Policy,
               State: response.data.subscriptionDetails?.State,
               Gcas: response.data.subscriptionDetails?.GCAS,
               Organization: response.data.subscriptionDetails?.Organization,
               Vendor: response.data.subscriptionDetails?.Vendor,
               Plant: response.data.subscriptionDetails?.Plant,
               Brand: response.data.subscriptionDetails?.Brand,
               Segment: response.data.subscriptionDetails?.Segment,
               ManuFacturingStatus: response.data.subscriptionDetails["Manufacturing Status"],
               Owner: response.data.subscriptionDetails?.Owner,
               expirationDate: response.data.subscriptionDetails["Expiration Date"],
               subscriptionName: response.data.subscriptionDetails?.name
            }))
         }

      } catch (error) {
         setFormData((data) => ({
            ...data,
            Vendor: "XYZ",
            Plant: "ABC",
         }))

      }
   }

   function modalsettings() {
      try {
         var x = document.getElementsByTagName("body")[0]
         var y = document.getElementById("headcontainer")
         if (x) {
            x.style.padding = "0px"
            x.style.margin = "0px"
         }
         if (y) {
            y.style.padding = "0px 15px"
            y.style.margin = "0px"
         }
      } catch (error) {
         console.error("Error in modalsettings:", error)
      }
   }

   const handler = (code, msg) => {
      if (code === 401) {
         setSuccess(false)
         notAuthorized(navigate)
      }
      else if (code === 412 || code === 503) {
         setSuccess(false)
         setMessage(msg)
      } else if (code === 200) {
         setSuccess(true)
         setMessage(msg)
      }
      else {
         setSuccess(false)
         setMessage("Dynamic Subscription submission failed. Please contact SpecReaderExt.im@pg.com for help.")
      }
   }

   const prodDataType = () => {
      if (formData.Gcas && formData.Gcas.trim()) {
         setMessage("")
         setDisable(false)
         setBlinkSearch("reportOptions")
         return true
      }
      if (formData.productDataType !== "" && formData.productDataType !== "Empty") {
         setMessage("")
         setDisable(false)
         setBlinkSearch("reportOptions")
         return true
      }
      else {
         setMessage("Please select a Product Data Type")
         setBlinkSearch("highlightFields")
         setDisable(true)
         return false
      }
   }
   const handleSubmit = () => {
      if (prodDataType()) {
         setDoneLoading(true)
         setDisable(true)
         DSMReportGenerate(`${DS_SUBMIT}`, formData)
            .then((response) => {
               if (response.status === 200) {
                  handler(200, "")
                  alert("Your Subscription details will be updated shortly.")
                  navigate("/Subscription")
               }
               setDoneLoading(false)
            })
            .catch((error) => {
               if (error.response && error.response.status) {
                  const err = error.response.data ? error.response.data.message : error
                  handler(error.response.status, err)
               } else {
                  handler(1000, error)
               }
               setDoneLoading(false)
               setDisable(false)
            })
      } else {
         if (!formData.Gcas || !formData.Gcas.trim()) {
            setMessage("Please select a Product Data Type")
            setBlinkSearch("highlightFields")
         }
      }
   }

   const handleModalClick = (e) => {
      setDisable(false)
      setBlinkSearch("reportOptions")
      setMessage("")
      setFrom(e)
      setModalShow(true)
      setTimeout(modalsettings, 0)
   }

   const handleGCASModalClick = (e) => {
      setDisable(false)
      setBlinkSearch("reportOptions")
      setMessage("")
      setFrom(e)
      setShowGCASModal(true)
      setTimeout(modalsettings, 0)
   }
   const handleSetFrom = () => {
      setFrom("")
   }
   const handleChange = (e) => {
      const dropdown = ["productDataType", "Policy", "State", "expirationDate"]
      // Handle changes of every input feild
      const { name, value } = e.target
      if (value == "Clear") {
         setDisable(false)
         setBlinkSearch("reportOptions")
         setMessage("")
         setFormData((data) => ({
            ...data,
            [name]: "",
            ...(name === "Gcas" ? { productDataType: "" } : {}),
         }))
         if ((name === "Plant" || name === "Owner") && formData.productDataType === "All") {
            const newPlant = name === "Plant" ? "" : (formData.Plant || "")
            const newOwner = name === "Owner" ? "" : (formData.Owner || "")
            setShowAllWarning(!newPlant.trim() && !newOwner.trim())
         }
      }
      else if (dropdown.includes(e.target.name)) {
         const { name, value } = e.target
         setDisable(false)
         setBlinkSearch("reportOptions")
         setMessage("")
         setFormData((data) => ({
            ...data,
            [name]: value,
         }))
         if (name === "productDataType") {
            if (!policyVisible.includes(value)) {
               setFormData((data) => ({
                  ...data,
                  Policy: ""
               }))
            }
            if (value === "Qualification") {
               setFormData((data) => ({
                  ...data,
                  State: "Approved"
               }))
            } else {
               setFormData((data) => ({
                  ...data,
                  State: "Release"
               }))
            }
            // Show warning if ALL is selected and neither Plant nor Owner is selected
            if (value === "All") {
               setShowAllWarning(
                  (!formData.Plant || formData.Plant.trim() === "") &&
                  (!formData["Owner/Co-owner"] || formData["Owner/Co-owner"].trim() === "")
               );
            } else {
               setShowAllWarning(false);
            }
         }
      }
      else {
         setDisable(false)
         setBlinkSearch("reportOptions")
         setMessage("")
         const textVal = textValidation(e.target.value)
         if (textVal.props.children || e.target.value === "") {
            const { name, value } = e.target
            setFormData((data) => ({
               ...data,
               [name]: value,
            }))
            // If Plant or Owner/Co-owner changes, check warning
            if ((name === "Plant" || name === "Owner/Co-owner") && formData.productDataType === "All") {
               setShowAllWarning(
                  ((name === "Plant" ? value : formData.Plant) || "").trim() === "" &&
                  ((name === "Owner" ? value : formData.Owner) || "").trim() === ""
               );
            }
         }
      }
   }

   useEffect(() => {
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         if (searchID) {
            fetchData() //Fetch Data from API
         }
      }
   }, [navigate, searchID])

   const isGcasSelected = !!(formData.Gcas && formData.Gcas.trim())

   return (
      <React.Fragment>
         <HeaderComponent />
         <br />
         <br />
         <Container fluid>
            <Row >
               <Col
                  md={{ span: 10, offset: 1 }}
                  className="contentBackground reportForm shadow"
               >
                  <Form>
                     <Col md="12" align="center" className="loginTextHeader">
                        {formData.subscriptionID !== "" ? "Edit Dynamic Subscription" : "Create Dynamic Subscription"}
                     </Col>
                     <br />
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="impInput">Product Data Type</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              as="select"
                              id="productDataType"
                              name="productDataType"
                              className={`${blinkSearch}`}
                              value={formData.productDataType}
                              onChange={handleChange}
                              disabled={isGcasSelected}
                           >
                              {ProductDataType &&
                                 ProductDataType.map((item, index) => (
                                    <option value={item.value} key={index}>{item.display}</option>
                                 ))}
                           </Form.Control>
                        </Col>
                        <Col sm="2" md="2" style={{ color: "#a00" }}>
                           {message === "Please select a Product Data Type" ? message : ""}
                        </Col>
                     </Row>
                     <Row>
                        <Col md="12" sm="12" align="center">
                           {showAllWarning && (
                              <p style={{ color: '#a00', fontWeight: 'bold' }}>
                                 Please select a plant or owner to ensure the correct subscriptions are received.
                              </p>
                           )}
                        </Col>
                     </Row>


                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels">Subscription Frequency</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="SF"
                              type="text"
                              name="SubsFrequency"
                              className="reportOptions"
                              placeholder={formData.SubsFrequency}
                              readOnly
                           ></Form.Control>
                        </Col>
                     </Row>
                     {policyVisible.includes(formData.productDataType) &&
                        <Row className="mb-3">
                           <Col sm="5" md="5">
                              <span className="reportLabels" id="Policy">Policy</span>
                           </Col>
                           <Col sm="4" md="4">
                              <Form.Control
                                 as="select"
                                 id="Policy"
                                 name="Policy"
                                 className="reportOptions"
                                 value={formData.Policy}
                                 onChange={handleChange}
                                 disabled={isGcasSelected}
                              >
                                 <option value="">--------Select Policy--------</option>
                                 <option value="Manufacturer Equivalent">
                                    Manufacturer Equivalent
                                 </option>
                                 <option value="Supplier Equivalent">
                                    Supplier Equivalent
                                 </option>
                              </Form.Control>
                           </Col>
                        </Row>}
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="impInput">State</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="State"
                              as="select"
                              className="reportOptions"
                              value={formData.State}
                              name="State"
                              onChange={handleChange}
                           >
                              {formData.productDataType === "Qualification" ? qualificationState.map((item, index) => (
                                 <option value={item.value} key={index}>{item.display}</option>
                              )) : otherState.map((item, index) => (
                                 <option value={item.value} key={index}>{item.display}</option>
                              ))}
                           </Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Gcas">GCAS Search</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Gcas"
                              type="text"
                              className="reportOptions"
                              value={formData.Gcas || ""}
                              name="Gcas"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              style={{ backgroundColor: 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Gcas1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => handleGCASModalClick("Gcas")}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="GcasClear"
                              type="button"
                              value="Clear"
                              name="Gcas"
                              className="reportOptions"
                              onClick={handleChange}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>




                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Organization">Organization</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Organization"
                              type="text"
                              className="reportOptions"
                              value={formData.Organization || ""}
                              name="Organization"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Organization1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => handleModalClick("Organization")}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="OrganizationClear"
                              type="button"
                              value="Clear"
                              name="Organization"
                              className="reportOptions"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Vendor">Vendor</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Vendor"
                              type="text"
                              className="reportOptions"
                              value={formData.Vendor || ""}
                              name="Vendor"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Vendor1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => {
                                 handleModalClick("Vendor")
                              }}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="VendorClear"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="Vendor"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Plant">Plant</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Plant"
                              type="text"
                              className="reportOptions"
                              value={formData.Plant || ""}
                              name="Plant"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Plant1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => {
                                 handleModalClick("Plant")
                              }}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="PlantClear"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="Plant"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Brand">Brand</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Brand"
                              type="text"
                              className="reportOptions"
                              value={formData.Brand || ""}
                              name="Brand"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Brand1"
                              type="button"
                              className="reportOptions"
                              disabled={isGcasSelected}
                              value="..."
                              onClick={() => {
                                 handleModalClick("Brand")
                              }}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="BrandClear"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="Brand"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Segment2">Segment</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Segment2"
                              type="text"
                              className="reportOptions"
                              value={formData.Segment || ""}
                              name="Segment"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Segment1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => {
                                 handleModalClick("Segment")
                              }}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="Segment"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="Segment"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="ManuFacturingStatus">Manufacturing Status</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="ManuFacturingStatus"
                              type="text"
                              className="reportOptions"
                              value={formData.ManuFacturingStatus || ""}
                              name="ManuFacturingStatus"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="expire1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => {
                                 handleModalClick("ManuFacturingStatus")
                              }}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="expireClear"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="ManuFacturingStatus"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>

                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="ExpiDate">Expiration Date</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              as="select"
                              id="ExpiDate"
                              className="reportOptions"
                              value={formData.expirationDate}
                              name="expirationDate"
                              onChange={handleChange}
                           >
                              {ExpirationDate &&
                                 ExpirationDate.map((item, index) => (
                                    <option value={item.value} key={index}>{item.display}</option>
                                 ))}
                           </Form.Control>
                        </Col>
                     </Row>
                     <Row className="mb-3">
                        <Col sm="5" md="5">
                           <span className="reportLabels" id="Owner">Owner/Co-owner</span>
                        </Col>
                        <Col sm="4" md="4">
                           <Form.Control
                              id="Owner"
                              type="text"
                              className="reportOptions"
                              value={formData.Owner || ""}
                              name="Owner"
                              onChange={handleChange}
                              autoComplete="off"
                              readOnly
                              disabled={isGcasSelected}
                              style={{ backgroundColor: isGcasSelected ? '' : 'white' }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="expire1"
                              type="button"
                              className="reportOptions"
                              value="..."
                              onClick={() => {
                                 handleModalClick("Owner")
                              }}
                              disabled={isGcasSelected}
                              style={{ width: "auto" }}
                           ></Form.Control>
                        </Col>
                        <Col sm="1" md="1">
                           <Form.Control
                              id="expireClear"
                              type="button"
                              className="reportOptions"
                              value="Clear"
                              name="Owner"
                              onClick={handleChange}
                              disabled={isGcasSelected}
                              style={{ minWidth: "fit-Content" }}
                           ></Form.Control>
                        </Col>
                     </Row>
                     <br />
                     <Row>
                        <Col md="12" sm="12" align="center">
                           <p style={{ marginTop: "4px", fontWeight: "bold" }} className={(success ? 'successMsg' : 'alertMsg')}>
                              {message !== "Please select a Product Data Type" ? message : ""}
                           </p>
                        </Col>
                     </Row>
                     <br />
                     <Row>
                        <Col sm="4" md="4"></Col>
                        <Col sm="2" md="2" align="right">
                           <Button variant="primary" onClick={handleSubmit} disabled={disable} >
                              {doneLoading ? (
                                 <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }} />
                              ) : (
                                 <span>Done</span>
                              )}
                           </Button>
                        </Col>
                        <Col sm="2" md="2">
                           <Button variant="primary" onClick={() => navigate("/Subscription")}>Cancel</Button>
                        </Col>
                        <Col sm="4" md="4"></Col>
                     </Row>
                  </Form>
               </Col>
            </Row>
            <br />
         </Container>
         <div>
            <SearchDSData
               show={modalShow}
               onHide={(e) => {
                  setModalShow(false)
                  if (from && e !== undefined) {
                     setFormData((data) => ({
                        ...data,
                        [from]: e,
                     }))
                     if ((from === "Plant" || from === "Owner") && e.trim() !== "") {
                        setShowAllWarning(false)
                     }
                  }
               }}
               from={from}
               handleSetFrom={handleSetFrom}
            />
         </div>
         <div>
            <SearchGCASData
               show={showGCASModal}
               onHide={(e) => {
                  setShowGCASModal(false)
                  if (from && e !== undefined) {
                     setFormData((data) => ({
                        ...data,
                        [from]: e,
                        ...(from === "Gcas" ? {
                           productDataType: "All",
                           Policy: "",
                           State: "Release",
                           Organization: "",
                           Vendor: "",
                           Plant: "",
                           Brand: "",
                           Segment: "",
                           ManuFacturingStatus: "",
                           Owner: "",
                        } : {}),
                     }))
                     if (from === "Gcas") setShowAllWarning(false)
                  }
               }}
               from={from}
               handleSetFrom={handleSetFrom}
            />
         </div>
      </React.Fragment>
   )
}
export default CreateDynamicSub